<template>
  <div>
    <CardedDisplay>
      <PlainDisplay :show_icon="false">
        <PromotionHeader
          :is_loading="is_loading"
          :promotion="promotion"
          :is_owner_view="is_owner_view"
          :is_in_admin_view="is_in_admin_view"
        ></PromotionHeader>
      </PlainDisplay>
    </CardedDisplay>
    <CardedSectionHeader
      icon="mdi-power"
      label="Edit Promotion Form"
      id="owner_edit_promotion_section"
    >
        <v-btn
        @click="$router.go(-1)"
        small
        rounded
        class="mr-4"
        outlined
        color="default"
      >
        <v-icon left>mdi-cancel</v-icon> Cancel Edit
      </v-btn>
    </CardedSectionHeader>
    <OwnerPrommotionsAdd
        :is_editing="true"
        :promotion_to_edit="promotion"
        ref="owners_promotion_add_view_ref"
        @on-updated-promotion="updated_promotion"
        @on-hide-loader="$emit('on-hide-loader')"
        @on-show-loader="$emit('on-show-loader')"
        :is_loading="is_loading"
    >
    </OwnerPrommotionsAdd>
  </div>
</template>

<script>
import ServerClient from "../../../lib/ServerClient";
import CardedDisplay from "./../../../components/CardedDisplay";
import PlainDisplay from "./../../../components/PlainDisplay";
import PromotionHeader from "./../../../components/PromotionHeader";
import CardedForm from "./../../../components/CardedForm";
import CardedSectionHeader from "./../../../components/CardedSectionHeader";
import Utils from "../../../lib/Utils";
import OwnerPrommotionsAdd from "./OwnerPrommotionsAdd";
export default {
  name: "OwnerPromotionsEdit",
  components: {
    CardedDisplay,
    PlainDisplay,
    PromotionHeader,
    CardedForm,
    CardedSectionHeader,
    OwnerPrommotionsAdd
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    is_owner_view: {
      type: Boolean,
      default: true,
    },
    is_in_admin_view: {
      type: Boolean,
      default: false,
    },
    is_in_public_view: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      promotion_id: 0,
      promotion: Utils.get_default_promotion(),
      is_owner: false,
      errors: [],
      message: "",
    };
  },
  methods: {
    on_auto_fill() {
      //no need for this method here
    },
    load_promotion() {
      this.$emit("on-show-loader");
      ServerClient.Promotions.get_promotion(
        {
          id: this.promotion_id,
          get_header_only: true,
        },
        (res) => {
          this.$emit("on-hide-loader");
          //   console.log("This one ", res);
          var php_time_now = parseFloat(Utils.date_str_to_php_time(""));
          res.expiry = "";
          if (php_time_now < parseFloat(res.starts_on_timestamp)) {
            res.expiry = "pending";
          } else if (
            php_time_now >= parseFloat(res.starts_on_timestamp) &&
            php_time_now <= parseFloat(res.ends_on_timestamp)
          ) {
            res.expiry = "live";
          } else if (php_time_now > parseFloat(res.ends_on_timestamp)) {
            res.expiry = "expired";
          }

          this.promotion = res;
          if (
            this._user &&
            this._user != null &&
            this.promotion.business &&
            parseInt(this._user.id) == parseInt(this.promotion.business.user_id)
          ) {
            this.is_owner = true;
          }
          this.$refs.owners_promotion_add_view_ref.init_form();
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log(
            "Errors while loading prmomotion details on owners promotion end view",
            errors
          );
        }
      );
    },
    updated_promotion() {
      this.load_promotion();
    }
  },
  mounted() {
    this.promotion_id = parseInt(this.$route.params.id);
    this._user = ServerClient.Login.get_logged_in_user();

    this.$emit("set-page-attributes", {
      title: "Edit Promotion",
      crumps: [
        {
          text: "Owner",
          disabled: false,
          href: "/owner",
        },
        {
          text: "Promotions",
          disabled: false,
          href: "/owner/promotions",
        },
        {
          text: "List",
          disabled: false,
          href: "/owner/promotions/list",
        },
        {
          text: "View",
          disabled: false,
          href: "/owner/promotions/list/view/" + this.promotion_id,
        },
        {
          text: "Edit",
          disabled: true,
          href: "/owner/promotions/list/view/" + this.promotion_id + "/edit",
        },
      ],
      navbar_cols: 3,
    });
    this.load_promotion();

    var options = {
      offset: 50,
      duration: 1000,
      easing: "easeInOutCubic",
    };
    this.$vuetify.goTo("#owner_edit_promotion_section", options);
  },
};
</script>